import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvGroup, AvInput, AvForm, AvFeedback } from 'availity-mobx-reactstrap-validation';
import { Label, FormGroup, Input } from 'reactstrap';

import { default as FormState } from 'js/stores/pages/MyAccountPageState/ReceivingAccount';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import Title from './Title';
import Icon from './Icon';

@observer
export default class EditForm extends Component {
  form = FormState.create(getSnapshot(this.props.state));

  onSubmit = () =>
    this.form.saveBankAccount().then(bankAccount =>
      this.props.state.onComplete({
        bankAccount,
      }),
    );

  render() {
    const form = this.form;
    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>
          <Icon name="university" />

          <Title>Receiving account</Title>

          <AvGroup>
            <Label for="aba_number">Routing Number</Label>
            <AvInput
              name="aba_number"
              id="aba_number"
              onChange={form.bankAccount.setRoute}
              value={form.bankAccount.route}
              required
            />
            <AvFeedback>Please enter your bank routing number</AvFeedback>
          </AvGroup>
          <AvGroup>
            <Label for="account_number">Account Number</Label>
            <AvInput
              name="account_number"
              id="account_number"
              onChange={form.bankAccount.setNumber}
              value={form.bankAccount.number}
              onFocus={form.clearNumber}
              required
            />
            <AvFeedback>Please enter your bank account number</AvFeedback>
          </AvGroup>
          <FormGroup>
            <Label for="type">Account Type</Label>
            <Input
              type="select"
              name="select"
              id="type"
              value={form.bankAccount.type}
              onChange={form.bankAccount.setType}>
              <option value="Checking">Checking</option>
              <option value="Savings">Savings</option>
              <option value="BusinessCK">Business Checking</option>
            </Input>
          </FormGroup>
          <ErrorDisplay>{form.error}</ErrorDisplay>
          <SubmitRow>
            <Button isLoading={form.isSaving} autoFocus type="submit">
              Save
            </Button>
          </SubmitRow>
        </AvForm>
      </Container>
    );
  }
}
